import styled from 'styled-components';

export const MapContainer = styled.div`
  position: relative;
`;
